export const instantAccessItems: string[] = [
  'Tutti i 10 volumi completi, dalla 1ª primaria al biennio',
  'Teoria, esempi svolti e verifiche in ogni singolo anno',
  'Prove d’ingresso per individuare il livello di partenza di ogni studente',
  'Esercizi guidati e autonomi già pronti da stampare',
  'Materiale utilizzabile su carta o dal tablet, senza limiti',
  'Progetti, quiz e soluzioni complete per l’intero anno scolastico',
]
